import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/contratos/proveedores",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProveedorImpresion",
      component: () =>
        import(
          "@/modules/configuration/proveedor/views/ImpresionProveedores.vue"
        ),
    },
    {
      path: "/proveedorTab",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProveedorTab",
      component: () =>
        import("@/modules/configuration/commonsviews/ProveedorTab.vue"),
    },
    {
      path: "/404",
      meta: {
        public: true,
        requiresAuth: false,
      },
      name: "NotFound",
      component: () => import("@/views/general/NotFound.vue"),
    },
    {
      path: "/403",
      meta: {
        public: true,
        requiresAuth: false,
      },
      name: "AccessDenied",
      component: () => import("@/views/general/Deny.vue"),
    },
    {
      path: "/500",
      meta: {
        public: true,
        requiresAuth: false,
      },
      name: "ServerError",
      component: () => import("@/views/general/Error.vue"),
    },
    {
      path: "/loginNew",
      meta: {
        public: true,
        requiresAuth: false,
      },
      name: "LoginNew",
      component: () => import("@/modules/authentication/views/LoginNew.vue"),
    },
    {
      path: "/claveUnica/:ticket",
      meta: { public: true, requiresAuth: false },
      name: "ClaveUnica",
      component: () => import("@/modules/authentication/views/ClaveUnica.vue"),
    },
    {
      path: "/reset/password",
      meta: {
        public: true,
        requiresAuth: false,
      },
      name: "ResetPassword",
      component: () =>
        import("@/modules/authentication/views/ResetPassword.vue"),
    },
    {
      path: "/aplicacion/views/forms/usuario/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "UsuarioRegistra",
      component: () =>
        import("@/modules/configuration/usuario/views/UsuarioRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/contingencia/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ContingenciaRegistra",
      component: () =>
        import(
          "@/modules/impresion/views/contingencia/ContingenciaRegistra.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/progreso/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProgresoRegistra",
      component: () =>
        import("@/modules/distribucion/views/progreso/ProgresoRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/progreso/editar",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormProgresoDiario",
      component: () =>
        import("@/modules/distribucion/views/progreso/FormProgresoDiario.vue"),
    },
    {
      path: "/aplicacion/views/forms/recepcion/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "RecepcionRegistra",
      component: () =>
        import("@/modules/aplicacion/views/recepcion/RecepcionRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/recepcion/editar",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormRecepcion",
      component: () =>
        import("@/modules/aplicacion/views/recepcion/FormRecepcion.vue"),
    },

    {
      path: "/aplicacion/views/forms/centro",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormCentroAp",
      component: () =>
        import("@/modules/aplicacion/views/centros/FormCentro.vue"),
    },
    {
      path: "/capacitacion/views/forms/centro",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormCentroCap",
      component: () =>
        import("@/modules/capacitacion/views/centros/FormCentro.vue"),
    },

    {
      path: "/aplicacion/views/forms/centro/observacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormObservacion",
      component: () =>
        import("@/modules/aplicacion/views/centros/FormObservacion.vue"),
    },

    {
      path: "/aplicacion/views/forms/revision",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormRevision",
      component: () =>
        import("@/modules/aplicacion/views/revision/FormRevision.vue"),
    },

    {
      path: "/aplicacion/views/forms/traspaso/co",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormTraspasoCO",
      component: () =>
        import("@/modules/aplicacion/views/traspasoCo/FormTraspaso.vue"),
    },
    {
      path: "/aplicacion/views/forms/captura/planificacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormPlanificacionCaptura",
      component: () =>
        import("@/modules/aplicacion/views/captura/FormPlanificacion.vue"),
    },
    {
      path: "/aplicacion/views/forms/captura/ejecucion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormEjecucionCaptura",
      component: () =>
        import("@/modules/aplicacion/views/captura/FormEjecucion.vue"),
    },
    {
      path: "/aplicacion/views/forms/cronograma/co",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormCronogramaCO",
      component: () =>
        import("@/modules/aplicacion/views/traspasoCo/FormCronograma.vue"),
    },
    {
      path: "/aplicacion/views/forms/cronograma/ca",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormCronogramaCA",
      component: () =>
        import("@/modules/aplicacion/views/traspasoCa/FormCronograma.vue"),
    },
    {
      path: "/aplicacion/views/forms/curso/ingreso",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormIngresoCursoApli",
      component: () =>
        import("@/modules/aplicacion/views/aplicacion/FormIngreso.vue"),
    },
    {
      path: "/aplicacion/views/forms/curso/aplicado",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormAplicadoCursoApli",
      component: () =>
        import("@/modules/aplicacion/views/aplicacion/FormAplicados.vue"),
    },
    {
      path: "/aplicacion/views/forms/curso/no-aplicado",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormNoAplicadoCursoApli",
      component: () =>
        import("@/modules/aplicacion/views/aplicacion/FormNoAplicados.vue"),
    },

    {
      path: "/aplicacion/views/forms/traspaso/ca",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormTraspasoCA",
      component: () =>
        import("@/modules/aplicacion/views/traspasoCa/FormTraspaso.vue"),
    },

    {
      path: "/aplicacion/views/forms/contingencia/registra/mecanizado",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ContingenciaRegistraMecanizado",
      component: () =>
        import(
          "@/modules/mecanizado/views/contingencia/ContingenciaRegistra.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/candidatos/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "CandidatosRegistra",
      component: () =>
        import(
          "@/modules/aplicacion/views/seleccion/candidatos/CandidatosRegistra.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/evaluacion/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "EvaluacionRegistra",
      component: () =>
        import(
          "@/modules/aplicacion/views/seleccion/evaluacion/EvaluacionRegistra.vue"
        ),
    },
    {
      path: "/captura/views/forms/scan/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ScanRegistra",
      component: () =>
        import("@/modules/captura/views/seguimiento/scan/ScanRegistra.vue"),
    },
    {
      // anteriores a 2020
      path: "/captura/views/forms/gridCuadraturaAnt",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridCuadraturaAnt",
      component: () =>
        import("@/modules/captura/views/cuadratura/GridCuadraturaAnt.vue"),
    },
    {
      path: "/captura/views/forms/gridCuadratura",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridCuadratura",
      component: () =>
        import("@/modules/captura/views/cuadratura/GridCuadratura.vue"),
    },
    //dsoto
    {
      path: "/captura/views/forms/gridCuadraturaSerie",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridCuadraturaSerie",
      component: () =>
        import("@/modules/captura/views/cuadratura/GridCuadraturaSerie.vue"),
    },

    //dsoto
    {
      path: "/captura/views/forms/digitacion/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "DigitacionRegistra",
      component: () =>
        import(
          "@/modules/captura/views/seguimiento/digitacion/DigitacionRegistra.vue"
        ),
    },
    {
      path: "/captura/views/forms/destruccion/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "DestruccionRegistra",
      component: () =>
        import("@/modules/captura/views/destruccion/DestruccionRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/visita/registra/aplicacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "VisitaRegistraAplicacion",
      component: () =>
        import(
          "@/modules/aplicacion/views/visita/VisitaRegistraAplicacion.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/aplicacion/registra/solicitudCambio",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "SolicitudesCambio",
      component: () =>
        import(
          "@/modules/aplicacion/views/seleccion/aplicacion/solicitudesCambio/SolicitudesCambioData.vue"
        ),
    },
    {
      path: "/capacitacion/views/forms/relator/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "RelatorRegistra",
      component: () =>
        import("@/modules/capacitacion/views/relator/RelatorRegistra.vue"),
    },
    {
      path: "/capacitacion/views/forms/sesionesFormativa/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "SesionesFormativaRegistra",
      component: () =>
        import(
          "@/modules/capacitacion/views/relator/SesionesFormativaRegistra.vue"
        ),
    },
    {
      path: "/capacitacion/views/forms/relator/evaluacionRegistra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "EvaluacionRelatorRegistra",
      component: () =>
        import(
          "@/modules/capacitacion/views/relator/EvaluacionRelatorRegistra.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/reportes/GridHistorico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistorico",
      component: () =>
        import("@/modules/aplicacion/views/reportes/GridHistorico.vue"),
    },
    //TODO BORRAR!??
    {
      path: "/impresion/views/forms/reportes/GridHistorico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoImpresion",
      component: () =>
        import("@/modules/impresion/views/reportes/GridHistorico.vue"),
    },
    {
      path: "/captura/views/forms/reportes/GridHistorico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoCaptura",
      component: () =>
        import("@/modules/captura/views/reportes/GridHistorico.vue"),
    },
    {
      path: "/aplicacion/views/forms/acomodacion/detalle",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormAcomodaciones",
      component: () =>
        import("@/modules/aplicacion/views/acomodacion/FormAcomodaciones.vue"),
    },
    {
      path: "/impresion/views/forms/reportes/GridAprobacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoImpresionReporte",
      component: () =>
        import("@/modules/impresion/views/reportes/GridAprobacion.vue"),
    },
    {
      path: "/captura/views/forms/reportes/GridExcepcionesTotales",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridExcepcionesTotales",
      component: () =>
        import("@/modules/captura/views/reportes/GridExcepcionesTotales.vue"),
    },

    {
      path: "/aplicacion/views/forms/reportes/GridAprobacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoReporte",
      component: () =>
        import("@/modules/aplicacion/views/reportes/GridAprobacion.vue"),
    },
    {
      path: "/captura/views/forms/reportes/GridAprobacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoCapturaReporte",
      component: () =>
        import("@/modules/captura/views/reportes/GridAprobacion.vue"),
    },
    {
      path: "/aplicacion/views/forms/reportes/ProductoRegistra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProductosRegistra",
      component: () =>
        import("@/modules/aplicacion/views/reportes/ProductosRegistra.vue"),
    },
    {
      path: "/captura/views/forms/reportes/ProductoRegistra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProductosRegistraCaptura",
      component: () =>
        import("@/modules/captura/views/reportes/ProductosRegistra.vue"),
    },
    {
      path: "/impresion/views/forms/reportes/ProductoRegistra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProductosRegistraImpresion",
      component: () =>
        import("@/modules/impresion/views/reportes/ProductosRegistra.vue"),
    },
    {
      path: "/prodReport/views/forms/reportes/SuperProductoRegistra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormSuperProducto",
      component: () =>
        import("@/modules/prodReport/views/SuperProductoRegistra.vue"),
    },
    {
      path: "/prodReport/views/forms/reportes/GridHistorico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoProdReporte",
      component: () => import("@/modules/prodReport/views/GridHistorico.vue"),
    },
    {
      path: "/prodReport/views/forms/reportes/GridAprobacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridHistoricoReporteAprobacion",
      component: () => import("@/modules/prodReport/views/GridAprobacion.vue"),
    },
    {
      path: "/prodReport/views/forms/reportes/ProductoRegistraReporte",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProductosRegistraReporte",
      component: () =>
        import("@/modules/prodReport/views/ProductosRegistraReporte.vue"),
    },
    {
      path: "/aplicacion/views/forms/acuerdo/detalle/historico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "DetalleHistoricoAcuerdo",
      component: () =>
        import("@/modules/impresion/views/acuerdo/DetalleHistoricoAcuerdo.vue"),
    },
    {
      path: "/aplicacion/views/forms/acuerdo/detalle/historico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "DetalleHistoricoAcuerdoDist",
      component: () =>
        import(
          "@/modules/distribucion/views/acuerdo/DetalleHistoricoAcuerdo.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/validacion/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ValidacionRegistra",
      component: () =>
        import("@/modules/impresion/views/validaciones/ValidacionRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/validacion/historico",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ValidacionHistoricoImpresion",
      component: () =>
        import(
          "@/modules/impresion/views/validaciones/ValidacionHistorico.vue"
        ),
    },
    {
      path: "/aplicacion/views/forms/calidad/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "CalidadRegistra",
      component: () =>
        import("@/modules/impresion/views/calidad/CalidadRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/calidad/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "CalidadRegistraMecanizado",
      component: () =>
        import("@/modules/impresion/views/calidad/CalidadRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/visita/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "VisitaRegistra",
      component: () => import("@/modules/visitas/views/VisitaRegistra.vue"),
    },
    {
      path: "/distribucion/views/forms/evolucion/region",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "EvolucionRegion",
      component: () =>
        import("@/modules/distribucion/views/evolucion/EvolucionRegion.vue"),
    },
    {
      path: "/aplicacion/views/forms/contacto/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ContactoRegistra",
      component: () =>
        import("@/modules/configuration/contacto/views/ContactoRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/contrato/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ContratoRegis",
      component: () =>
        import("@/modules/configuration/contrato/ContratoRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/contrato/edit",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ContratoEdit",
      component: () =>
        import("@/modules/configuration/contrato/ContratoEdit.vue"),
    },
    {
      path: "/proceso/impresion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProcesoImpresion",
      component: () =>
        import("@/modules/configuration/commonsviews/ProcesoImpresion.vue"),
    },
    {
      path: "/proceso/aplicacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProcesoAplicacion",
      component: () =>
        import("@/modules/configuration/commonsviews/ProcesoAplicacion.vue"),
    },
    {
      path: "/proceso/capacitacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProcesoCapacitacion",
      component: () =>
        import("@/modules/configuration/commonsviews/ProcesoCapacitacion.vue"),
    },
    {
      path: "/proceso/captura",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProcesoCaptura",
      component: () =>
        import("@/modules/configuration/commonsviews/ProcesoCaptura.vue"),
    },
    {
      path: "/proceso/preguntas",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProcesoPreguntas",
      component: () =>
        import("@/modules/configuration/commonsviews/ProcesoPreguntas.vue"),
    },
    {
      path: "/proceso/validaciones",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ProcesoValidaciones",
      component: () =>
        import("@/modules/configuration/commonsviews/ProcesoValidaciones.vue"),
    },
    {
      path: "/proceso/captura/recepcion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "FormRecepcionCaptura",
      component: () =>
        import("@/modules/captura/views/recepcion/FormRecepcion.vue"),
    },
    {
      path: "/configuracion/auditoria",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "Auditoria",
      component: () =>
        import("@/modules/configuration/auditoria/views/Auditoria.vue"),
    },
    {
      path: "/configuracion/log",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ApplicationLog",
      component: () =>
        import("@/modules/configuration/log/views/ApplicationLog.vue"),
    },
    {
      path: "/configuracion/mecanizadoInfo",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "Mecanizado Info",
      component: () =>
        import(
          "@/modules/configuration/mecanizadoHistory/views/MecanizadoHistory.vue"
        ),
    },
    {
      path: "/configuracion/pagosymultas",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "PagosMultasSelect",
      component: () =>
        import(
          "@/modules/configuration/pagosymultas/views/PagosMultasSelect.vue"
        ),
    },
    {
      path: "/configuracion/pagosymultasnuevo",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "PagosMultasSelectNuevo",
      component: () =>
        import(
          "@/modules/configuration/pagosymultasnuevo/PagosMultasSelectNuevo.vue"
        ),
    },
    {
      path: "/configuracion/pagosymultasnuevo",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "IngresoMultasSelectNuevo",
      component: () =>
        import(
          "@/modules/configuration/pagosymultasnuevo/IngresoMultasSelectNuevo.vue"
        ),
    },
    {
      path: "/configuracion/informacionContractual",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "AdministrativoContractual",
      component: () =>
        import(
          "@/modules/configuration/informacionContractual/views/AdministrativoContractual.vue"
        ),
    },

    //dsoto 03-01-2023
    {
      path: "/configuracion/GestionUsuario",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GestionUsuario",
      component: () =>
        import(
          "@/modules/configuration/gestionUsuario/views/GestionUsuario.vue"
        ),
    },
    //dsoto 03-01-2023

    //dsoto 05-01-2023
    {
      path: "/configuration/registrar",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "UsuarioRegistrar",
      component: () =>
        import(
          "@/modules/configuration/gestionUsuario/views/UsuarioRegistrar.vue"
        ),
    },
    //dsoto 05-01-2023

    {
      path: "/panelContratos",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "PanelContratos",
      component: () =>
        import(
          "@/modules/configuration/contrato/panelContrato/PanelContratos.vue"
        ),
    },
    {
      path: "/trazabilidad",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "Trazabilidad",
      component: () =>
        import(
          "@/modules/configuration/contrato/panelContrato/Trazabilidad.vue"
        ),
    },
    {
      path: "/TableroControl",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "TableroControl",
      component: () =>
        import(
          "@/modules/configuration/contrato/panelContrato/TableroControl.vue"
        ),
    },
    {
      path: "/configProveedor",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ConfigProveedor",
      component: () =>
        import("@/modules/configuration/proveedor/views/ConfigProveedor.vue"),
    },
    {
      path: "/edicion/proveedor",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "EdicionProveedor",
      component: () =>
        import("@/modules/configuration/proveedor/views/EdicionProveedor.vue"),
    },
    {
      path: "/impresion/contrato/registra",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ContratoRegistra",
      component: () =>
        import("@/modules/configuration/proveedor/views/ContratoRegistra.vue"),
    },
    {
      path: "/aplicacion/views/forms/usuario/edita",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "UsuarioEdita",
      component: () =>
        import("@/modules/configuration/usuario/views/UsuarioEdita.vue"),
    },
    {
      path: "/mecanizado",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "Mecanizado",
    },
    {
      path: "/usuarios",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridUsuario",
      component: () =>
        import("@/modules/configuration/usuario/views/GridUsuario.vue"),
    },
    {
      path: "/contactos",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GridContacto",
      component: () =>
        import("@/modules/configuration/contacto/views/GridContacto.vue"),
    },

    {
      path: "/registrocivil",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "RegistroCivil",
      component: () =>
        import("@/modules/configuration/registroCivil/views/RegistroCivil.vue"),
    },
    {
      path: "/videostutoriales",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "VideosTutoriales",
      component: () =>
        import(
          "@/modules/configuration/videoTutoriales/views/VideosTutoriales.vue"
        ),
    },
    {
      path: "/reporteria/graficas",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "GraficasReporteria",
      component: () =>
        import(
          "@/modules/configuration/reporteria/views/GraficasReporteria.vue"
        ),
    },
    {
      path: "/reporteria",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ReporteriaInfo",
      component: () =>
        import("@/modules/configuration/reporteria/views/ReporteriaInfo.vue"),
    },
    {
      path: "/mecanizadoHistory",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "MecanizadoHistory",
      component: () =>
        import(
          "@/modules/configuration/mecanizadoHistory/views/MecanizadoHistory.vue"
        ),
    },
    {
      path: "/mecanizadoCrear",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "MecanizadoHistoryData",
      component: () =>
        import(
          "@/modules/configuration/mecanizadoHistory/views/MecanizadoHistoryRegistra.vue"
        ),
    },

    {
      path: "/botones/impresion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "BotonesImpresion",
      component: () =>
        import(
          "@/modules/configuration/commonsviews/BotonesProcesoImpresion.vue"
        ),
    },
    {
      path: "/botones/aplicacion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "BotonesAplicacion",
      component: () =>
        import(
          "@/modules/configuration/commonsviews/BotonesProcesoAplicacion.vue"
        ),
    },

    {
      path: "/dashboard/impresion",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "DashboardImpresion",
      component: () =>
        import("@/modules/dashboards/impresion/views/DashboardImpresion.vue"),
    },
    {
      path: "/panelControlTab",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "PanelControlTab",
      component: () =>
        import("@/modules/configuration/contrato/PanelControlTab.vue"),
    },
    {
      path: "/validacion/visita",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "InfraestructuraData",
      component: () =>
        import(
          "@/modules/validaciones/views/infraestructura/InfraestructuraData.vue"
        ),
    },
    {
      path: "/validacion/asistencia",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ValArchivo",
      component: () =>
        import(
          "@/modules/validaciones/views/asistencia/AsistenciaValidaciones.vue"
        ),
    },
    {
      path: "/validacion/asistencia/data",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ValArchivoData",
      component: () =>
        import("@/modules/validaciones/views/asistencia/AsistenciaData.vue"),
    },
    {
      path: "/validacion/especificacion/data",
      meta: { breadcrumb: true, requiresAuth: true, public: false },
      name: "ValArchivoEspecData",
      component: () =>
        import(
          "@/modules/validaciones/views/especificacion/EspecificacionData.vue"
        ),
    },
    {
      path: "/components/alert",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/alerts",
      component: () => import("@/views/ui/Alert.vue"),
    },
    {
      path: "/components/avatar",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/avatars",
      component: () => import("@/views/ui/Avatar.vue"),
    },
    {
      path: "/components/badge",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/badges",
      component: () => import("@/views/ui/Badge.vue"),
    },
    {
      path: "/components/button",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/buttons",
      component: () => import("@/views/ui/Button.vue"),
    },
    {
      path: "/components/parallax",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/parallax",
      component: () => import("@/views/ui/Parallax.vue"),
    },
    {
      path: "/components/snackbar",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/snackbar",
      component: () => import("@/views/ui/Snackbar.vue"),
    },
    {
      path: "/components/chip",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/chips",
      component: () => import("@/views/ui/Chip.vue"),
    },
    {
      path: "/components/table",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/tables",
      component: () => import("@/views/ui/Tables.vue"),
    },
    {
      path: "/components/carousel",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/carousels",
      component: () => import("@/views/ui/Carousels.vue"),
    },
    {
      path: "/components/dialog",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/dialogs",
      component: () => import("@/views/ui/Dialogs.vue"),
    },
    {
      path: "/components/icon",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/icons",
      component: () => import("@/views/ui/Icon.vue"),
    },
    {
      path: "/components/progress",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/progress",
      component: () => import("@/views/ui/Progress.vue"),
    },
    {
      path: "/components/slider",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/sliders",
      component: () => import("@/views/ui/Slider.vue"),
    },
    {
      path: "/components/tooltip",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/tooltips",
      component: () => import("@/views/ui/Tooltip.vue"),
    },
    {
      path: "/components/pagination",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/paginations",
      component: () => import("@/views/ui/Pagination.vue"),
    },
    {
      path: "/pickers/datepicker",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "pickers/datepicker",
      component: () => import("@/views/ui/Datepicker.vue"),
    },
    {
      path: "/components/typography",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/typography",
      component: () => import("@/views/ui/Typography.vue"),
    },
    {
      path: "/components/color",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/color",
      component: () => import("@/views/ui/Colors.vue"),
    },
    {
      path: "/pickers/timepicker",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "pickers/timepicker",
      component: () => import("@/views/ui/Timepicker.vue"),
    },
    {
      path: "/layout/timeline",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/timeline",
      component: () => import("@/views/layout/Timeline.vue"),
    },
    {
      path: "/layout/toolbar",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/toolbar",
      component: () => import("@/views/layout/Toolbar.vue"),
    },
    {
      path: "/layout/menu",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/menus",
      component: () => import("@/views/layout/Menus.vue"),
    },
    {
      path: "/layout/navigation-drawer",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/navigation-drawers",
      component: () => import("@/views/layout/NavigationDrawers.vue"),
    },
    {
      path: "/layout/tabs",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/tabs",
      component: () => import("@/views/layout/Tabs.vue"),
    },
    {
      path: "/widgets/social",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/social",
      component: () => import("@/views/widgets/Social.vue"),
    },
    {
      path: "/widgets/post",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/widget-post",
      component: () => import("@/views/widgets/Post.vue"),
    },
    {
      path: "/widgets/statistic",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/statistic",
      component: () => import("@/views/widgets/Statistic.vue"),
    },
    {
      path: "/widgets/chart",
      meta: { breadcrumb: true, requiresAuth: false, public: true },
      name: "components/chart",
      component: () => import("@/views/widgets/Chart.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // console.log("st::detalle:" + JSON.stringify(to, null, 2));
  // console.log("st::next:" + JSON.stringify(next, null, 2));
  // Redirigir a HTTPS para todas las demas rutas
  // && process.env.NODE_ENV === 'production'
  /*if (window.location.protocol !== 'https:') {
    window.location.href = 'https://' + window.location.host + to.fullPath;
    return;
  }*/
  //  console.log("aaa::" + to.meta.public);
  if (to.meta.public != true) {
    //  console.log("bbb");
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      
      if (store.getters.isLoggedIn) {
        //  console.log("ddd");
        next();
        return;
      }
//se revisa si hay token porque en estado se pierde al hacer f5
      const token = localStorage.getItem("token");
      if(!!token) {
        next();
        return;
      }else{
        console.log("cuando se le da f5 no persiste y se sale de la app");
        next("/loginNew");
      }


      
    }
    if (/*to.path === '/' && */ to.query.ticket) {
      const ticket = to.query.ticket;
      next({ path: `/claveUnica/ticket=${ticket}` });
    } else {
      //  console.log("fff");
      next("/loginNew");
    }
  } else {
    //  console.log("ggg");
    next();
  }
});

export default router;
